const LOGO_URL = 'https://storage.readdy-site.link/project_files/84f75d7c-5aa3-41e4-b7ad-dd29b3b984c6/838cdbab-d32d-4b26-b12c-15bffc18506a_poktapok_v1_sin-fondo.png';

export default function Footer() {
  return (
    <footer className="bg-red-700 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo y descripcion */}
          <div className="md:col-span-1">
            <img
              src={LOGO_URL}
              alt="PokTaPok"
              className="h-20 w-auto object-contain mb-4"
            />
            <p className="text-red-100 mb-4">
              La plataforma lider para encontrar y reservar las mejores canchas de futbol en Mexico.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-red-100 hover:text-white transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-red-100 hover:text-white transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-red-100 hover:text-white transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-red-100 hover:text-white transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Enlaces rapidos */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Enlaces Rapidos</h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-red-100 hover:text-white transition-colors cursor-pointer">Inicio</a></li>
              <li><a href="/" className="text-red-100 hover:text-white transition-colors cursor-pointer">Buscar Canchas</a></li>
              <li><a href="/anuncio" className="text-red-100 hover:text-white transition-colors cursor-pointer">Publicar Anuncio</a></li>
              <li><a href="/nosotros" className="text-red-100 hover:text-white transition-colors cursor-pointer">Nosotros</a></li>
              <li><a href="/contacto" className="text-red-100 hover:text-white transition-colors cursor-pointer">Contacto</a></li>
              <li><a href="/poktatoken" className="text-red-100 hover:text-white transition-colors cursor-pointer">PokTaToken</a></li>
              <li><a href="/roadmap" className="text-red-100 hover:text-white transition-colors cursor-pointer">Roadmap</a></li>
              <li><a href="https://readdy.ai/?origin=logo" className="text-red-100 hover:text-white transition-colors cursor-pointer">Made with Readdy</a></li>
            </ul>
          </div>

          {/* Categorias */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Categorias</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-red-100 hover:text-white transition-colors cursor-pointer">Futbol 11</a></li>
              <li><a href="#" className="text-red-100 hover:text-white transition-colors cursor-pointer">Futbol 7</a></li>
              <li><a href="#" className="text-red-100 hover:text-white transition-colors cursor-pointer">Futbol 5</a></li>
              <li><a href="#" className="text-red-100 hover:text-white transition-colors cursor-pointer">Futsal</a></li>
              <li><a href="#" className="text-red-100 hover:text-white transition-colors cursor-pointer">Futbol Playa</a></li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-phone-line mr-3 text-white"></i>
                <span className="text-red-100">+52 55 1234 5678</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line mr-3 text-white"></i>
                <span className="text-red-100">info@poktapok.com</span>
              </div>
              <div className="flex items-start">
                <i className="ri-map-pin-line mr-3 text-white mt-1"></i>
                <span className="text-red-100">Ciudad de Mexico, Mexico</span>
              </div>
            </div>
          </div>
        </div>

        {/* Linea divisoria */}
        <hr className="border-red-600 my-8" />

        {/* Copyright */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-red-200 text-sm">
            2026 PokTaPok. Todos los derechos reservados.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-red-200 hover:text-white text-sm transition-colors cursor-pointer">
              Terminos de Servicio
            </a>
            <a href="#" className="text-red-200 hover:text-white text-sm transition-colors cursor-pointer">
              Politica de Privacidad
            </a>
            <a href="#" className="text-red-200 hover:text-white text-sm transition-colors cursor-pointer">
              Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}